import { Button } from 'shared/components/ui';
import React, { useState, useRef, useEffect } from 'react';
import { Chat, Close, Send, CallEnd, Person } from '@mui/icons-material';
import { useChat } from '../hooks/useChat';
import './ChatWidget.css';

const ChatWidget = () => {
  const { pendientes, chatActivo, mensajes, isOpen, setIsOpen, aceptarChat, enviarMensaje, finalizarChat, totalPendientes } = useChat();
  const [texto, setTexto] = useState('');
  const mensajesEndRef = useRef(null);

  useEffect(() => {
    mensajesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensajes]);

  const handleEnviar = async (e) => {
    e.preventDefault();
    await enviarMensaje(texto);
    setTexto('');
  };

  return (
    <div className="chat-widget">
      {isOpen && (
        <div className="chat-panel">
          <div className="chat-panel-header">
            <span>{chatActivo ? `Chat con ${chatActivo.paciente?.nombre || chatActivo.telefono}` : 'Chats de WhatsApp'}</span>
            <div className="chat-header-actions">
              {chatActivo && (
                <Button className="chat-btn-finalizar" onClick={finalizarChat} title="Finalizar llamada" aria-label="Finalizar llamada">
                  <CallEnd sx={{ fontSize: 18 }} />
                </Button>
              )}
              <Button className="chat-btn-close" onClick={() => setIsOpen(false)}>
                <Close sx={{ fontSize: 18 }} />
              </Button>
            </div>
          </div>

          <div className="chat-panel-body">
            {!chatActivo ? (
              // Lista de solicitudes pendientes
              pendientes.length === 0 ? (
                <div className="chat-empty">
                  <Person sx={{ fontSize: 40, opacity: 0.3 }} />
                  <p>No hay pacientes esperando</p>
                </div>
              ) : (
                pendientes.map(s => (
                  <div key={s.id} className="chat-solicitud-item">
                    <div className="chat-solicitud-info">
                      {s.tipo === 'token' && <span className="chat-etiqueta-token">Token obra social</span>}
                      {s.paciente ? (
                        <>
                          <span className="chat-paciente-nombre">{s.paciente.nombre}</span>
                          <span className="chat-paciente-datos">
                            DNI {s.paciente.dni}{s.paciente.obraSocial ? ` · ${s.paciente.obraSocial}` : ''}
                          </span>
                          <span className="chat-paciente-datos">
                            {s.paciente.estudio}{s.paciente.fecha ? ` · ${new Date(s.paciente.fecha).toLocaleString('es-AR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}` : ''}
                          </span>
                        </>
                      ) : (
                        <span className="chat-telefono">{s.telefono}</span>
                      )}
                      <span className="chat-hora">{new Date(s.fechaSolicitud).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}</span>
                    </div>
                    <Button className="chat-btn-aceptar" onClick={() => aceptarChat(s)}>
                      Atender
                    </Button>
                  </div>
                ))
              )
            ) : (
              // Conversación activa
              <div className="chat-mensajes">
                {chatActivo.paciente && (
                  <div className="chat-paciente-cabecera">
                    {chatActivo.tipo === 'token' && <span className="chat-etiqueta-token">Token obra social</span>}
                    <strong>{chatActivo.paciente.nombre}</strong>
                    <span>DNI {chatActivo.paciente.dni}{chatActivo.paciente.obraSocial ? ` · ${chatActivo.paciente.obraSocial}` : ''}</span>
                    <span>{chatActivo.paciente.estudio}</span>
                  </div>
                )}
                {mensajes.map(m => (
                  <div key={m.id} className={`chat-burbuja ${m.remitente === 'operador' ? 'operador' : 'usuario'}`}>
                    {m.imagen && (
                      <a href={m.imagen} target="_blank" rel="noopener noreferrer">
                        <img src={m.imagen} alt="Captura enviada por el paciente" className="chat-imagen" />
                      </a>
                    )}
                    {m.mensaje && <p>{m.mensaje}</p>}
                    <span className="chat-burbuja-hora">{new Date(m.fecha).toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' })}</span>
                  </div>
                ))}
                <div ref={mensajesEndRef} />
              </div>
            )}
          </div>

          {chatActivo && (
            <form className="chat-input-area" onSubmit={handleEnviar}>
              <input
                value={texto}
                onChange={e => setTexto(e.target.value)}
                placeholder="Escribir mensaje..."
                className="chat-input"
                autoFocus
              />
              <Button type="submit" className="chat-btn-send" disabled={!texto.trim()}>
                <Send sx={{ fontSize: 18 }} />
              </Button>
            </form>
          )}
        </div>
      )}

      <button className="chat-fab" onClick={() => setIsOpen(o => !o)} title="Chats de pacientes">
        <Chat sx={{ fontSize: 22 }} />
        {totalPendientes > 0 && <span className="chat-fab-badge">{totalPendientes}</span>}
      </button>
    </div>
  );
};

export default ChatWidget;
